export function isRecruitmentEventType(
  arg: any
): arg is Application.RecruitmentEvent {
  return (
    arg && typeof arg.name === "string" && typeof arg.description === "string"
  );
}

export function isCompetitorEventType(
  arg: any
): arg is Application.CompetitorEvent {
  return (
    arg && typeof arg.name === "string" && typeof arg.graduate_year === "number"
  );
}

export function isStudentEventType(arg: any): arg is Application.StudentEvent {
  return (
    arg &&
    typeof arg.name === "string" &&
    typeof arg.description !== "string" &&
    typeof arg.graduate_year !== "number"
  );
}

export function enumToKeys<T>(enumObj: T) {
  return (Object.keys(enumObj) as Array<keyof T>).filter(
    value => isNaN(Number(value)) !== false
  );
}

export function enumToValues<T>(enumObj: T) {
  const keys = enumToKeys(enumObj);
  return keys.map(key => enumObj[key]);
}

/**
 * 配列からNull/Undefinedを取り除き、TSで検出します。
 * Array.filterの引数として指定します。
 */
export const isNotNullOrUndefined = <T>(v?: T | null): v is T => null != v;

/**
 * 一部のプロパティのみオプショナルにするUtility Types
 */
export type PartiallyPartial<T, K extends keyof T> = Omit<T, K> &
  Partial<Pick<T, K>>;

/**
 * 一部のプロパティのみ必須にするUtility Types
 */
export type PartiallyRequired<T, K extends keyof T> = Omit<T, K> &
  Required<Pick<T, K>>;

/**
 * オブジェクトの特定プロパティの型を上書きするUtility Types
 */
export type Overwrite<T, U extends { [Key in keyof T]?: unknown }> = Omit<
  T,
  keyof U
> &
  U;

/**
 * Number用型ガード
 */
export const isNumber = (value: any): value is number => {
  return typeof value === "number";
};

/**
 * String用型ガード
 */
export const isString = (value: any): value is string => {
  return typeof value === "string";
};
